import React, { useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { IoClose, IoWarning } from "react-icons/io5";
import { PrimaryButton } from "screens/perfilAutonomo/components/primaryButton.component";
import { MdOutlineLocalPrintshop } from "react-icons/md";
import { getGerarTemplateSolicitacao } from "screens/visitas/api/getGerarTemplateSolicitacao";
import { toast } from "react-toastify";
import { Loading } from "screens/perfilAutonomo/components/Loading";
import * as S from "./visualizarModal.styles";
import { LocChaveVisita, TDocVisita } from "../modalNova/utils";

export const VisualizarModal = ({
  open,
  onClose,
  solicitacao,
}: {
  open: boolean;
  onClose: () => void;
  solicitacao: any;
}) => {
  const [printing, setPrinting] = useState(false);

  const formatDate = (date: Date): string => {
    const result = date.toLocaleDateString("pt-BR", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const formatted = result?.charAt(0).toUpperCase() + result?.slice(1);
    return formatted;
  };

  const handlePrint = () => {
    setPrinting(true);
    getGerarTemplateSolicitacao(solicitacao?.idSolicitacaoVisita)
      .then(({ success, data }) => {
        if (success) {
          const fullBase64 = `data:${data?.contentType};base64,${data?.base64}`;
          const newTab = window.open();
          if (newTab) {
            newTab.document.write(`
              <html>
                <head>
                  <title>${data?.nome ?? "Template"}</title>
                  <style>
                    body { margin: 0; overflow: hidden; }
                    iframe { width: 100vw; height: 100vh; border: none; }
                  </style>
                </head>
                <body>
                  <iframe src="${fullBase64}"></iframe>
                </body>
              </html>
            `);
          } else {
            toast.error(
              "Não foi possível abrir a nova aba. Verifique as configurações do navegador."
            );
          }
        } else throw new Error();
      })
      .catch((error) => {
        toast.error(
          "Erro ao gerar template, por favor tente novamente mais tarde."
        );
        console.error(error);
      })
      .finally(() => {
        setPrinting(false);
      });
  };

  return (
    <S.DialogContainer open={open} onClose={onClose} maxWidth="md">
      <S.Container>
        <S.IconContainer>
          <div className="icon-wrapper">
            <FaCalendarAlt color="#333" />
          </div>
          <h1 className="title center">{"Visualizar Solicitação"}</h1>
          <IoClose size={26} className="exit" onClick={onClose} />
        </S.IconContainer>

        <S.WarningContainer>
          <IoWarning size={32} color="#F43636" />
          <p>{"Não esqueça de imprimir essa solicitação"}</p>
        </S.WarningContainer>

        <S.ContentContainer>
          <S.Row>
            <S.Info>
              <h3>{"Empreendimento:"}</h3>
              <p>{solicitacao?.nomeEmpreendimento ?? "--"}</p>
            </S.Info>

            <div>
              <S.Row>
                <S.Info>
                  <h3>{"Torre(s):"}</h3>
                </S.Info>
                <S.Info>
                  <h3>{"Unidade(s):"}</h3>
                </S.Info>
              </S.Row>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 6,
                  marginTop: 6,
                }}
              >
                {solicitacao?.locais?.map((item: any) => (
                  <S.Row key={item?.idTorre}>
                    <S.Info>
                      <p>{item?.torre ?? "--"}</p>
                    </S.Info>
                    <S.Info>
                      <p>{item?.unidade ?? "--"}</p>
                    </S.Info>
                  </S.Row>
                ))}
              </div>
            </div>
          </S.Row>

          {solicitacao?.convidadosCyrelaCia?.map((item: any) => (
            <S.Row key={item?.idUsuarioVisita}>
              <S.Info>
                <h3>{"Corretor(a):"}</h3>
                <p>{item?.nome ?? "--"}</p>
              </S.Info>
              <S.Info>
                <h3>
                  {typeof item?.tipoDocumento === "number"
                    ? `${TDocVisita[item?.tipoDocumento]?.split(" ")[0]}:`
                    : "Doc."}
                </h3>
                <p>{item?.documento ?? "--"}</p>
              </S.Info>
            </S.Row>
          ))}

          <S.Row>
            {solicitacao?.convidadosCliente?.length > 0 && (
              <S.Info>
                <h3>{"Cliente(s):"}</h3>
                {solicitacao?.convidadosCliente?.map((item: any) => (
                  <p key={item?.nome}>{item?.nome ?? "--"}</p>
                ))}
              </S.Info>
            )}
            <S.Info>
              <h3>{"Local das chaves:"}</h3>
              <p>{LocChaveVisita[solicitacao?.localizacaoChave] ?? "--"}</p>
            </S.Info>
          </S.Row>

          {solicitacao?.dadosVeiculo?.length > 0 && (
            <S.Row>
              <S.Info>
                <h3>{"Veículos"}</h3>
                {solicitacao?.dadosVeiculo?.map((item: any) => (
                  <p key={item?.placa}>{`${item?.veiculo ?? "--"} - ${
                    item?.placa ?? "--"
                  }`}</p>
                ))}
              </S.Info>
            </S.Row>
          )}

          <S.Info>
            <h3>{"Data:"}</h3>
            <p>
              {solicitacao?.dataAgendamento
                ? formatDate(new Date(solicitacao?.dataAgendamento))
                : "--/--/----"}
            </p>
          </S.Info>

          <S.Info>
            <h3>{"Horário solicitado:"}</h3>
            <p>
              {`${
                solicitacao?.horaInicioAgendamento?.substring(0, 5) ?? "--:--"
              } às ${
                solicitacao?.horaFimAgendamento?.substring(0, 5) ?? "--:--"
              }h.`}
            </p>
          </S.Info>

          <PrimaryButton
            content={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {printing ? (
                  <Loading color="white" size={22} />
                ) : (
                  <>
                    <MdOutlineLocalPrintshop size={22} />
                    <span>{"Imprimir"}</span>
                  </>
                )}
              </div>
            }
            disabled={printing}
            onClick={handlePrint}
          />
        </S.ContentContainer>
      </S.Container>
    </S.DialogContainer>
  );
};
